import { formatVariableValue } from "@velizhanin-dev/bot-scenario"
import { MapPin } from "lucide-react"
import type { AudienceCard } from "../api/audience-api"
import { mapUrl } from "../lib/map-url"
import { MemberFile } from "./audience-ui"

const LOCATION_PATTERN = /^(-?\d+(?:\.\d+)?),\s*(-?\d+(?:\.\d+)?)$/

export function VariableValueView({
	card,
	botId,
	name,
	type,
}: {
	card: AudienceCard
	botId: string
	name: string
	type?: string
}) {
	const value = card.member.vars[name]
	if (value === undefined || value === "") return <span className="text-muted-foreground">–</span>
	if (typeof value === "string" && type === "FILE") {
		const separator = value.indexOf(":")
		return (
			<MemberFile
				botId={botId}
				sessionId={card.member.id}
				kind={value.slice(0, separator)}
				fileId={value.slice(separator + 1)}
			/>
		)
	}
	const location =
		typeof value === "string" && type === "LOCATION" ? LOCATION_PATTERN.exec(value) : null
	if (location) {
		return (
			<a
				href={mapUrl(location[1], location[2])}
				target="_blank"
				rel="noreferrer"
				className="inline-flex items-center gap-1 text-primary"
			>
				<MapPin className="h-3.5 w-3.5" />
				На карте
			</a>
		)
	}
	return <span className="break-words whitespace-pre-wrap">{formatVariableValue(value)}</span>
}
